<template>
  <div class="w-full" :class="{ 'bg-gray-100/50 p-2 rounded': multiDateIsOpen }">
    <div class="flex justify-between w-full">
      <div class="flex group">
        <div
          class="flex-1"
          :class="{ 'font-black': multiDateIsOpen }"
          v-html="fnGetDateLabelHtml(optionData)"
        ></div>
        <div class="self-center">
          <EventBuyBoxTimeSlotsBadge
            class="ml-4"
            :date="optionData as EventDate"
          />
        </div>
      </div>

      <span
        v-if="showCollapseButton && !alwaysShowMultidate && hasChildren"
        class="fs-6"
        style="color: #dadada"
        @click.stop="multiDateIsOpen = !multiDateIsOpen"
      >
        <span v-show="!multiDateIsOpen"><PlusCircle class="h-4" /></span>
        <span v-show="multiDateIsOpen"><DashCircle class="h-4" /></span>
      </span>
    </div>
    <div v-if="computedShowChildrenDates" class="mt-2">
      <BulletPoints :items-html-arr="childrenHtmlArr" />
    </div>
  </div>
</template>

<script setup lang="ts">
import PlusCircle from '~/assets/icons/plus-circle.svg?component'
import DashCircle from '~/assets/icons/dash-circle.svg?component'
import { EventDate, EventDateChildren } from '~/composables/types/event'

defineOptions({ name: 'EventBuyBoxDateOption' })

const props = defineProps<{
  optionData: EventDate | EventDateChildren
  alwaysShowMultidate: boolean
  forceShowMultidate: boolean
  showCollapseButton: boolean
}>()

const { fnGetChildrenHtmlArr, fnGetDateLabelHtml } = useEventDateHelpers()

const multiDateIsOpen = ref(
  props.optionData.children?.data?.length > 0 && props.optionData.order === 1
)

const childrenHtmlArr = computed(() => fnGetChildrenHtmlArr(props.optionData))

const hasChildren = computed(() => props.optionData?.children?.data?.length > 0)

const isSoldOut = computed(() => props.optionData.status === 'SOLD_OUT')

const computedShowChildrenDates = computed(() => {
  return (
    (!isSoldOut.value &&
      (props.alwaysShowMultidate || props.forceShowMultidate) &&
      hasChildren.value) ||
    multiDateIsOpen.value
  )
})
</script>
